// The maintenance types the log form offers.
//
// Four are built into the product (Breakdown, Scheduled PM, Predictive Maintenance,
// Repair & Maintenance) and the rest are added by the plant in Settings. The list is
// fetched once after sign-in and kept here, so the form does not wait on a request
// every time it opens.
//
// The built-in four are also hardcoded as a fallback: if the fetch fails, the log form
// still offers the types the reports are built around rather than an empty dropdown.

import { apiCall } from "./api";
import { MT, MT_LABELS } from "./config";

const FALLBACK = [
  { key: MT.BREAKDOWN, label: MT_LABELS[MT.BREAKDOWN], isBreakdown: true, system: true },
  { key: MT.PM, label: MT_LABELS[MT.PM], isBreakdown: false, system: true },
  { key: MT.PREDICTIVE, label: MT_LABELS[MT.PREDICTIVE], isBreakdown: false, system: true },
  { key: MT.REPAIR, label: MT_LABELS[MT.REPAIR], isBreakdown: false, system: true },
];

let TYPES = FALLBACK;

export async function refreshMaintenanceTypes() {
  try {
    const rows = await apiCall("GET", "/maintenance-types");
    if (Array.isArray(rows) && rows.length) TYPES = rows;
  } catch { /* keep whatever we had — an empty dropdown is worse than a stale one */ }
  return TYPES;
}

export function maintenanceTypes() {
  return TYPES;
}

// key -> label, for showing the type on an entry that already has one.
export function maintenanceTypeLabel(key) {
  if (!key) return "";
  const hit = TYPES.find(t => t.key === key);
  // A type deleted after entries were filed against it still has to render.
  return hit ? hit.label : key;
}

export function resetMaintenanceTypes() {
  TYPES = FALLBACK;
}
